var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6875 4.84352V3.68652C3.6875 3.07321 3.93114 2.48502 4.36482 2.05134C4.79849 1.61766 5.38669 1.37402 6 1.37402C6.61331 1.37402 7.20151 1.61766 7.63518 2.05134C8.06886 2.48502 8.3125 3.07321 8.3125 3.68652V4.84302M4.2655 8.89002H7.7345M8.5 4.84352H3.5C2.81 4.84352 2.25 5.36102 2.25 5.99952V9.46852C2.25 10.107 2.81 10.6245 3.5 10.6245H8.5C9.19 10.6245 9.75 10.107 9.75 9.46852V5.99952C9.75 5.36102 9.19 4.84352 8.5 4.84352Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLogin);
export default __webpack_public_path__ + "static/media/btn_login.531b05b0b95e1d72f3fa9d9815a3ea93.svg";
export { ForwardRef as ReactComponent };